import React, {ReactElement} from 'react';
import PropTypes from 'prop-types';
import {MenuItem, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import securityService from 'core/security/securityService';
import {addTenantToQuery} from "core/common/utils/utils";
import Home from "material-ui/svg-icons/action/home";
import styled from "styled-components";
import {MODULE, PERMISSION, SECURABLE_TYPE} from "core/metamodel/metaConstant";

import "core/components/mainmenu/mainMenu.less";
import {observer} from "mobx-react";
import {LovItem} from "core/metamodel/mdEntity";
import {RestrictionData, Tenant, UserSession} from "core/security/securityDomain";
import {action} from "mobx";
import {lovLabel, lovValue} from "core/form/formUtils";
import {blueGrey200, blueGrey500, brown500, grey300, grey400, indigo500, teal500} from "material-ui/styles/colors";
import {changeLanguage, loc} from 'core/common/config/locales';
import employeeService from "humanresource/employeeService";
import {EmployeeAttendance} from "humanresource/humanResourceDomain";
import {formatDateTime, formatTime} from "core/common/utils/dateUtils";
import {root} from "rxjs/util/root";
import sbToolLogo from '../../../sbtool/images/sbtool-logo-smaller.png';


const envColors = {
  prod: indigo500,
  test: teal500,
  test2: blueGrey500,
  dev: brown500
};

interface MainMenuProps {
  currentUser: UserSession;
  currentTenant: Tenant;
  availableTenants: LovItem[];
  restrictionData: RestrictionData;
}

const environmentStyles = {backgroundColor: envColors[__ENVIRONMENT__]};

const HelpSpan = styled.span`
    color: ${blueGrey200};
    font-size: 15px;
    margin-top:12px;
    margin-right: 12px;
`;


@observer
export default class MainMenu extends React.Component<MainMenuProps, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };



  /* *******   EVENT HENDLERS ************ */

  @action logout = (eventKey, event) => {
    console.log('logout');
    event.preventDefault();

    securityService.logout()
      .then(action("logout-action", (response) => {
        securityService.setUserContextDto({});
        window.location.assign(this.context.router.makePath('loginPage'));
      }), (err) => {
        console.log('logout error');
      });
  };

  @action attendanceHandler = (eventKey, event) => {
    console.log('attendanceHandler');
    event.preventDefault();

    const {currentUser, restrictionData} = this.props;

    employeeService.employeeAttendanceSave({partyId: currentUser.partyId, coming: restrictionData.showComing()})
      .then(action("employeeAttendanceSave-action", (data) => {
        let employeeAttendance = new EmployeeAttendance(data);
        restrictionData.lastComingTime = employeeAttendance.comingTime;
        restrictionData.lastLeavingTime = employeeAttendance.leavingTime;
      }), (err) => {
        console.log('employeeAttendanceSave error');
      });
  };




  onSelectWithTransition = (eventKey, event) => {
    console.log('onSelect2: event = %o, eventKey = %o', event, eventKey);
    event.preventDefault();
    this.context.router.transitionTo(eventKey);
  };

  onSelectLanguage = (eventKey, event) => {
    changeLanguage(eventKey, event);
  };


  onHome = (event) => {
    event.preventDefault();
    let currentUser = this.props.currentUser;
    if (currentUser && currentUser.username === 'autoneum_gate') {
      this.context.router.transitionTo("shipmentVisitDetail", {id: 'new'});
    } else {
      this.context.router.transitionTo("home");
    }
  };

  changeTenant = (tenantId: number, eventKey, event) => {
    event.preventDefault();

    console.log('changeTenant ' + tenantId, event);

    if (tenantId != null) {
      securityService.changeLastTenant(tenantId)
        .then(() => {
          window.sessionStorage.setItem('tenantId', tenantId.toString());
          window.TENANT_ID = tenantId.toString();
          window.localStorage.clear();
          window.location.reload(true);
        });
    }
  };

  clearCache = (eventKey, event) => {
    console.log('clearCache');
    event.preventDefault();

    console.log('clearCache');
    window.localStorage.clear();
    window.location.reload(true);
  };


  getCompanyLogo = () : ReactElement => {
    const {currentTenant} = this.props;

    // TODO : Nico predelej to
    if (currentTenant && currentTenant.tenantId === 17) {
      return <img src={sbToolLogo} alt={"SbTool"}/>
    }

    return <Home color={grey300} hoverColor={grey400}/>
  }



  /* *******   REACT METHODS ************ */

  render() {


    const {
      currentUser,
      currentTenant,
      availableTenants,
      restrictionData
    } = this.props;

    console.log('MAIN MENU CURRENT USER = %O, tenant = %O, tenants = %O', currentUser, currentTenant, availableTenants);

    const tenantsForChange = (availableTenants) ? availableTenants.filter(lov => lovValue(lov) !== currentTenant.tenantId): [];

    const languagesFrag = (
      <NavDropdown id="languages_menu_dropdown" eventKey={3} title={ <span style={{textTransform: 'uppercase'}}>{loc.lang}</span> } >
        {
          loc.available.filter(x => x !== loc.lang).map((locale) => {
            return (
              <MenuItem eventKey={locale} key={locale} onSelect={this.onSelectLanguage} style={{textTransform: 'uppercase'}}>{locale}</MenuItem>
            );
          })
        }
      </NavDropdown>
    );


    const mainMenuFrag = (
      <Nav navbar>
        <PrunedNavDropdown id="party_menu_dropdown" title={loc.i18n`Party`} onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.party} route="partyCustomers" />
          <PageLinkMenuItem module={MODULE.party} route="partyContacts" />
          <PageLinkMenuItem module={MODULE.party} route="partySalesReps" />
          <PageLinkMenuItem module={MODULE.party} route="partySuppliers" />
          <PageLinkMenuItem module={MODULE.party} route="partyHaulers" />
          <PageLinkMenuItem module={MODULE.party} route="partyDrivers" />
          <MenuItem divider/>
          <PageLinkMenuItem module={MODULE.party} route="partyAll"/>
          <MenuItem divider/>
          <PageLinkMenuItem module={MODULE.core} route="contractList"/>
        </PrunedNavDropdown>

        <PrunedNavDropdown id="invoice_menu_dropdown"  title={loc.i18n`Invoice`} onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.invoicing} route="issuedInvoiceList"/>
          <PageLinkMenuItem module={MODULE.invoicing} route="invoiceTemplateList"/>
          <MenuItem divider/>
          <PageLinkMenuItem module={MODULE.invoicing} route="invoiceReport"/>
          <PageLinkMenuItem module={MODULE.invoicing} route="entityNumberGenGroupList"/>
        </PrunedNavDropdown>

        <PrunedNavDropdown id="assets_menu_dropdown"  title={loc.i18n`Assets`} onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.product} route="vehicleList"/>
          <PageLinkMenuItem module={MODULE.shipment} route="shipmentOutgoingList"/>
          <PageLinkMenuItem module={MODULE.shipment} route="shipmentIncomingList"/>
          <PageLinkMenuItem module={MODULE.shipment} route="shipmentRepackagingList"/>
          <PageLinkMenuItem module={MODULE.shipment} route="shipmentVisitList"/>
          <MenuItem divider/>
          <PageLinkMenuItem module={MODULE.product} route='brimMessageList'/>
          <PageLinkMenuItem module={MODULE.shipment} route="shipmentReport"/>
        </PrunedNavDropdown>

        <PrunedNavDropdown id="product_menu_dropdown"  title={loc.i18n`Products`} onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.product} route="productList"/>
          <PageLinkMenuItem module={MODULE.product} route="priceComponentList"/>
        </PrunedNavDropdown>

        <PrunedNavDropdown id="crm_menu_dropdown"  title='CRM' onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.core} route="taskList"/>
          <PageLinkMenuItem module={MODULE.core} route="activityList"/>
          <PageLinkMenuItem module={MODULE.core} route="eventList"/>
          <PageLinkMenuItem module={MODULE.humanresource} route="timeSheetReport"/>
        </PrunedNavDropdown>

        <PrunedNavDropdown id="sbtool_menu_dropdown"  title='SBTool' onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.sbtool} route="sbToolProjectsList" />
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolCriteriaList" title={loc.i18n`Criteria menu`}/>*/}
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolMaterialsList" title={loc.i18n`Materials menu`}/>*/}
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolLifespanList" title={loc.i18n`Lifespan menu`}/>*/}
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolEnergyCarriersList" title={loc.i18n`Energy carriers menu`}/>*/}
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolMaterialUsageGroupList" title={loc.i18n`Usage groups menu`}/>*/}
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolRoomTypeList" title={loc.i18n`Room types menu`}/>*/}
          {/*<PageLinkMenuItem module={MODULE.sbtool} route="sbToolAreaList" title={loc.i18n`Area menu`}/>*/}
        </PrunedNavDropdown>


        <PrunedNavDropdown id="administration_dropdown"  title={loc.i18n`Administration`} onSelect={this.onSelectWithTransition}>
          <PageLinkMenuItem module={MODULE.core} route="userList"/>
          <PageLinkMenuItem module={MODULE.core} route="securityRoleList"/>
          <PageLinkMenuItem module={MODULE.core} route="jobList"/>
          <PageLinkMenuItem module={MODULE.core} route="entityList"/>
          <PageLinkMenuItem module={MODULE.core} route="gridLocationList"/>
          <PageLinkMenuItem module={MODULE.core} route="documentTypeList"/>
          <PageLinkMenuItem module={MODULE.core} route="eventTypeList"/>
          <PageLinkMenuItem module={MODULE.core} route="activityConfigList"/>
          <PageLinkMenuItem module={MODULE.core} route="serverOverview" params={{tab: 'info'}}/>
          <PageLinkMenuItem module={MODULE.core} route="referenceList"/>
          <PageLinkMenuItem module={MODULE.core} route="certificateList"/>
          <PageLinkMenuItem module={MODULE.core} route="paramKeyList"/>
        </PrunedNavDropdown>


      </Nav>
    );



    return (
      <Navbar inverse fixedTop fluid style={environmentStyles} collapseOnSelect>

        <Navbar.Header>
          <Navbar.Brand>
            <a href={this.context.router.makeHref('home', null, addTenantToQuery())} onClick={this.onHome}>
              {this.getCompanyLogo()}
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>

        <Navbar.Collapse>

          { currentUser ? mainMenuFrag : '' }

          <Nav navbar pullRight >
            { currentUser ? (
              <NavDropdown eventKey={3} id="user_menu_dropdown" title={currentUser ? (currentUser.displayName + ((restrictionData.employer) ? (' - ' + lovLabel(restrictionData.employer)) : '')  + ' (' + currentTenant.label + ')' ) : ''}>
                { this._menuItem("userProfile", undefined, undefined, (eventKey, event) => {event.preventDefault(); this.context.router.transitionTo("userProfile", {tab: "info"});} ) }
                {(currentUser.hasRight("employeeAttendance", PERMISSION.Update)) ? (
                  <MenuItem eventKey='attendance' onSelect={this.attendanceHandler}>{restrictionData.showComing() ? loc.i18n`Coming` : (loc.i18n`Leaving` + ' (' + formatTime(restrictionData.lastComingTime) + ' - ?)') }</MenuItem>
                ) : null}
                <MenuItem eventKey='clearCache' onSelect={this.clearCache}>Clear cache</MenuItem>
                <MenuItem eventKey='logout' onSelect={this.logout}>Logout</MenuItem>
                {(tenantsForChange.length) ?<MenuItem divider/> : null}
                { tenantsForChange.map( (li,i) => <MenuItem eventKey={li.value} key={li.value} onSelect={this.changeTenant.bind(this, li.value)} > {li.label} </MenuItem>) }
              </NavDropdown>
            ) : null }
            {languagesFrag}
            <a href="/doc/index.html" target="_blank">
              <HelpSpan className="fa fa-question"/>
            </a>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }


  _menuItem(route, title, icon, onSelect) {
    let routeObj = this.context.router.namedRoutes[route];
    let routeHandler = (routeObj) ? routeObj.handler : null;
    let resolvedTitle = (title) ? title : ((routeHandler) ? routeHandler.title : null);

    let menuItemProps: any = {
      href: this.context.router.makeHref(route, null, addTenantToQuery()),
      eventKey: route
    };
    if (onSelect) {
      menuItemProps.onSelect = onSelect;
    }

    return <MenuItem {...menuItemProps}> {resolvedTitle} </MenuItem>;
  }

}

interface ZzMenuItemProps {
  module?: MODULE;
  route?: string;
  title?: string;
  icon?: string;
  onSelect?: Function;
  params?: {[key: string]: any};
  query?: {[key: string]: any};
}

const PageLinkMenuItem: React.StatelessComponent<ZzMenuItemProps> = ({module, route, title, icon, onSelect, params, query}: ZzMenuItemProps, context) => {

  let routeObj = context.router.namedRoutes[route];
  let routeHandler = (routeObj) ? routeObj.handler : null;
  let resolvedTitle = (title) ? title : ((routeHandler) ? routeHandler.title : null);

  let menuItemProps: any = {
    href: context.router.makeHref(route, params, addTenantToQuery(query)),
    eventKey: route
  };
  if (onSelect) {
    menuItemProps.onSelect = onSelect;
  }

  return <MenuItem {...menuItemProps}> {resolvedTitle} </MenuItem>;
};
PageLinkMenuItem.contextTypes = {router: PropTypes.func.isRequired};


const PrunedNavDropdown = ({id, title, onSelect, children}: { id: string, title: string, onSelect: Function, children: any }) => {
  let filteredChildren = React.Children.toArray(children).filter((child: any) => !child.props.module || securityService.hasRight(child.props.route, PERMISSION.Read)) as React.ReactElement[];

  // vyhodim 2 dividery za sebou, pokud je prvni nebo posledni element divider, tak taky
  if (filteredChildren.length) {
    let prevChild = filteredChildren[0];
    let newChildren = (prevChild.props.module) ? [prevChild] : [];
    for(let i = 1; i < filteredChildren.length; i++) {
      if (prevChild.props.module || filteredChildren[i].props.module) {
        newChildren.push(filteredChildren[i]);
      }
      prevChild = filteredChildren[i];
    }
    if (newChildren.length && !newChildren[newChildren.length-1].props.module) newChildren.pop();
    filteredChildren = newChildren;
  }

  return (filteredChildren.length && filteredChildren.find(ch => ch.props.module)) ? (
    <NavDropdown id={id} title={title} onSelect={onSelect}>
      {filteredChildren}
    </NavDropdown>
  ) : <noscript/>
};






// WEBPACK FOOTER //
// ./src/core/components/mainmenu/mainMenu.tsx